// This function returns the updated course pause duration
// Here pauseDuration is current pause duration
// updateDurationType is whether to reduce or extend the pause
// updateDurationBy refers to months to extend pause by
function getUpdatedPauseDuration(
  pauseDuration,
  updateDurationType,
  updateDurationBy
) {
  if (!updateDurationBy || !updateDurationType) return pauseDuration;

  switch (updateDurationType) {
    case 'reduce':
      return pauseDuration - updateDurationBy;
    case 'extend':
      return pauseDuration + updateDurationBy;
    default:
      break;
  }
}

export default getUpdatedPauseDuration;
